import React from 'react';

import Inquisitive2025 from 'views/Inquisitive2025';

const SchoolProgrampage = () => {
  return <Inquisitive2025 />;
};

export default SchoolProgrampage;